module.exports = __webpack_public_path__ + "static/media/analysis-svgrepo-com.e500e5e8.svg";